import { Table, Tag } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Text from 'components/Text';

const StyledLink = styled(Link)`
  color: #53b297;

  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * FinishedTable
 * @param {*} props 
 * @returns 
 */
const FinishedTable = (props) => {
  const columns = [
    {
      title: 'Date',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, record) => <>{moment(record.created_at).format('DD/MM/YYYY')}</>,
    },
    {
      title: 'Prix',
      dataIndex: 'amount',
      key: 'amount',
      render: (text, record) => <>{record ? record.amount : text.toFixed(2)}€</>,
    },
    {
      title: 'Statut',
      dataIndex: 'disabled',
      key: 'disabled',
      render: (text, record) => (
        <>
          {
            record.refunded ? (
              <Tag color='red'>Avoir</Tag>
            ) : (
              <>
                {
                  record._refund_from ? (
                    <Tag color='green'>Avoir</Tag>
                  ) : (
                    <Tag color={record.draft === false ? 'blue' : 'orange'}>{record.draft === false ? 'Edité' : 'A finaliser'}</Tag>                    
                  )
                }
              </>
            )
          }
  
        </>
      ),
    },

    {
      title: 'Details',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => (
        <>
        {
          record._basket ? (
            <StyledLink to={`/orders/details/${record._basket._id}`}>Détails</StyledLink>
          ) : (
            <StyledLink to={`/orders/bill_details/${record._id}`}>Détails</StyledLink>
          )
        }
        </>
      ),
    },
  ];

  const dataSource = props.bills
  .sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at)
  })
  .filter((entry) => entry.paid === true)
  .map((entry) => {
    return {
      ...entry,
      key: entry._d
    }
  })

  return (
    <>
      <Text size={14} style={{ marginBottom: 10 }}>Vos commandes terminée</Text>
      <Table dataSource={dataSource} columns={columns} size="small"/>
    </>
  )
}

export default withTranslation()(FinishedTable);